import { useQuery } from "@tanstack/react-query";
import { useUser } from "../useUserProvider";
import { profilesQueryOptions } from "./profilesQuery";

export const useGetProfiles = (options: { enabled?: boolean } = {}) => {
  const { accessToken } = useUser();

  return useQuery({
    ...profilesQueryOptions(),
    enabled: !!accessToken && (options.enabled ?? true),
  });
};
